var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_download_18_line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2363 9.37641V12.5264C13.2363 12.9202 12.9176 13.2389 12.5238 13.2389H5.47383C5.08008 13.2389 4.76133 12.9202 4.76133 12.5264V9.37641H3.48633V12.5264C3.48633 13.6214 4.37883 14.5139 5.47383 14.5139H12.5238C13.6188 14.5139 14.5113 13.6214 14.5113 12.5264V9.37641H13.2363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99883 10.7939C9.29508 10.7939 9.58008 10.6702 9.78633 10.4564L12.0551 8.07516L11.1326 7.19391L9.63633 8.76516V3.50391H8.36133V8.76516L6.86508 7.19391L5.94258 8.07516L8.21133 10.4564C8.41383 10.6702 8.70258 10.7939 8.99883 10.7939Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.b5da2816.svg";
export { ForwardRef as ReactComponent };